import { CongregacionFiltro } from '../enums/congregacion-filtro.enum';
import { PersonTableColumn } from '../interfaces/person-table.interface';

const COL_OPCIONES: PersonTableColumn = { key: 'opciones', header: 'Opciones' };
const COL_NOMBRE: PersonTableColumn = { key: 'nombre', header: 'Nombre y Apellido' };
const COL_EDAD: PersonTableColumn = { key: 'edad', header: 'Edad' };
const COL_LIDER: PersonTableColumn = { key: 'lider', header: 'Líder' };
const COL_CELULAR: PersonTableColumn = { key: 'celular', header: 'Celular' };
const COL_CUMPLE: PersonTableColumn = { key: 'cumpleEn', header: 'Cumple en:' };
const COL_LOCALIDAD: PersonTableColumn = { key: 'localidad', header: 'Localidad' };
const COL_MOTIVO: PersonTableColumn = { key: 'motivo', header: 'Motivo' };
const COL_FALTAS: PersonTableColumn = { key: 'faltas', header: 'Faltas' };
const COL_ESTADO: PersonTableColumn = { key: 'estado', header: 'Estado' };
const COL_REUNION: PersonTableColumn = { key: 'reunion', header: 'Reunion' };

/** Columnas visibles segun filtro de Congregacion (matriz mayorap2). */
export function buildCongregacionColumns(
  filtro: CongregacionFiltro | string,
  cantCulto: number,
): PersonTableColumn[] {
  const columns: PersonTableColumn[] = [COL_OPCIONES, COL_NOMBRE, COL_EDAD];

  switch (filtro) {
    case CongregacionFiltro.Muelle:
      columns.push(COL_CELULAR, COL_LOCALIDAD);
      break;
    case CongregacionFiltro.Faltas:
      columns.push(COL_LIDER, COL_FALTAS);
      break;
    case CongregacionFiltro.Monitoreo:
      columns.push(COL_CELULAR, COL_ESTADO);
      break;
    case CongregacionFiltro.Cumple:
      columns.push(COL_LIDER, COL_CUMPLE);
      break;
    case CongregacionFiltro.Estudiantes:
      columns.push(COL_LIDER, COL_MOTIVO);
      break;
    case CongregacionFiltro.Lideres:
      columns.push(COL_LIDER);
      if (cantCulto !== 1) {
        columns.push(COL_REUNION);
      }
      break;
    case CongregacionFiltro.PorNombre:
    case CongregacionFiltro.Ninguno:
    default:
      columns.push(COL_LIDER);
      if (cantCulto !== 1) {
        columns.push(COL_REUNION);
      }
      break;
  }

  return columns;
}
